import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kd-animation-success',
  templateUrl: './animation-success.component.html',
  styleUrls: ['./animation-success.component.scss']
})
export class AnimationSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
